const B = 1;
const KB = B * 1024;
const MB = KB * 1024;
const GB = MB * 1024;

function round(x) {
    return Math.round(x * 100) / 100;
}

export default function bytes2hr(bytes) {
    let gb = 0,
        mb = 0,
        kb = 0,
        b = bytes;

    b -= (gb = Math.floor(b / GB)) * GB;
    b -= (mb = Math.floor(b / MB)) * MB;
    b -= (kb = Math.floor(b / KB)) * KB;

    if (gb > 0) {
        return `${round(gb)}GB`;
    } else if (mb > 0) {
        return `${round(mb)}MB`;
    } else if (kb > 0) {
        return `${round(kb)}KB`;
    } else {
        return `${b}B`;
    }
}
